import { Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { settings } from "app";

// Thin divider line that fades out away from the title. Uses the palette entry of `color` when it has one
// (primary, secondary, ...), otherwise primary (e.g. color="text.secondary").
// `direction` points from the transparent end toward the title.
const fadingLine = (color, direction) => theme => {
  const { main } = theme.palette[color]?.main ? theme.palette[color] : theme.palette.primary;
  return {
    content: '""',
    flex: 1,
    height: 2,
    borderRadius: 2,
    background: `linear-gradient(${direction}, ${alpha(main, 0)} 0%, ${alpha(main, 0.6)} 100%)`,
  };
};

// The old title - plain colored text - for tenants without the new UI (settings.style.modernUi).
// No padding by default, so headers migrated from a raw <Typography> keep their old spacing.
const LegacySectionTitle = ({ title, paddingY, paddingTop, textAlign, color, fontSize, sx }) => (
  <Typography
    color={color}
    paddingY={paddingY ?? 0}
    paddingTop={paddingTop}
    textAlign={textAlign}
    sx={{ ...sx, fontSize: fontSize ?? 16 }}
  >
    {title}
  </Typography>
);

export const SectionTitle = ({ title, paddingY, paddingTop, textAlign, color = "primary", fontSize, sx }) =>
  !settings.style.modernUi ? (
    <LegacySectionTitle
      title={title}
      paddingY={paddingY}
      paddingTop={paddingTop}
      textAlign={textAlign}
      color={color}
      fontSize={fontSize}
      sx={sx}
    />
  ) : (
    <Typography
      color={color}
      paddingY={paddingY ?? 2}
      paddingTop={paddingTop}
      textAlign={textAlign}
      sx={[
        {
          display: "flex",
          alignItems: "center",
          gap: 2,
          fontWeight: 600,
          // Centered: a line on both sides; otherwise only after the title.
          "&::before": textAlign === "center" ? fadingLine(color, "90deg") : { display: "none" },
          "&::after": fadingLine(color, "270deg"),
        },
        sx,
        { fontSize: fontSize ?? 18 },
      ]}
    >
      {title}
    </Typography>
  );
